module.exports = __webpack_public_path__ + "img/mie.dceb8b47.png";